import styled from 'styled-components';

export const BlockWrapper = styled.div`
    [class^='Blockstyle__Block-sc'] {
        padding: 32px 16px 24px 16px;

        @media (min-width: 768px) {
            padding: 64px 20px 56px 20px;
        }

        [class^='Blockstyle__ContentWrapper-sc'] {
            max-width: 1280px;
        }
    }
`;

export const HeadingWrapper = styled.div`
    margin-bottom: 20px;

    h3 {
        font-weight: 700;
        font-size: 28px;
    }

    @media (min-width: 768px) {
        margin-bottom: 48px;

        h3 {
            font-size: 40px;
        }
    }
`;

export const CtaButtonRowWrapper = styled.div`
    margin-top: 16px;

    @media (min-width: 768px) {
        margin-top: 40px;
    }
`;

export const AccordionWrapper = styled.div`
    [class^='Accordionstyle__Accordion-sc'] {
        [class^='Interactionstyle__BlankInteraction-sc'] {
            margin-bottom: 20px;
            padding: 16px;

            button {
                margin-bottom: 0;

                [class^='CollapsibleContainerHeaderstyle__Children-sc'] {
                    font-size: 18px;
                }
            }

            [class^='CollapsibleContainerBodystyle__CollapsibleContainerBody-sc'] {
                p {
                    text-align: start;
                    margin: 20px 0 0;
                }
            }

            :last-child {
                margin-bottom: 0;
            }
        }
    }
`;